import React from 'react'
import PropTypes from 'prop-types'
import { 
  InformationMain, 
  Heading
} from './index.style'
import Container from '@components/Container'
import RichText from '@components/RichText'
import Grid from '@components/Grid'
import GridItem from '@components/GridItem'
import Spacer from '@components/Spacer'
import { GatsbyImage } from 'gatsby-plugin-image'
import { colors } from '@styles/vars/colors.style'

const Information = ({ data, title }) => {

  const bgColor = colors.white;
  const fColor = colors.charcoal;
  
  return (
    <InformationMain backgroundColor={bgColor} fontColor={fColor}>
      <Spacer size={[60, 100]}/>
      <Container>
        <RichText
            content={data}
            as="p"
        />
      </Container>
      <Spacer size={[90, 120]}/>
    </InformationMain>
  )
}

Information.propTypes = {
  data: PropTypes.object,
}

export default Information
